// modules/teamOverlay.js
export function teamOverlay() {
  const cards = document.querySelectorAll('.multi-grid-card--team');
  if (!cards.length) return;

  let activeOverlay = null;

  cards.forEach(card => {
    const plus = card.querySelector('.multi-grid-card__plus');
    const overlay = card.querySelector('.multi-grid-card__overlay');

    if (!plus || !overlay) return;

    plus.addEventListener('click', e => {
      e.stopPropagation();

      // Zelfde overlay opnieuw aanklikken → sluiten
      if (overlay.classList.contains('multi-grid-card__overlay--active')) {
        overlay.classList.remove('multi-grid-card__overlay--active');
        activeOverlay = null;
        return;
      }

      // Sluit vorige open overlay
      if (activeOverlay && activeOverlay !== overlay) {
        activeOverlay.classList.remove('multi-grid-card__overlay--active');
      }

      // Activeer huidige overlay
      overlay.classList.add('multi-grid-card__overlay--active');
      activeOverlay = overlay;
    });
  });

  // Klik buiten kaarten → alles sluiten
  document.addEventListener('click', () => {
    if (activeOverlay) {
      activeOverlay.classList.remove('multi-grid-card__overlay--active');
      activeOverlay = null;
    }
  });
}
